import { observer } from "mobx-react-lite";

import { ConstantStyle } from "@/components/doc/right-sidebar/active-node-style/constant/ConstantStyle";
import { FunctionStyle } from "@/components/doc/right-sidebar/active-node-style/function/FunctionStyle";
import { GroupStyle } from "@/components/doc/right-sidebar/active-node-style/group/GroupStyle";
import { NumberStyle } from "@/components/doc/right-sidebar/active-node-style/number/NumberStyle";
import { PlaceholderStyle } from "@/components/doc/right-sidebar/active-node-style/placeholder/PlaceholderStyle";
import { VariableStyle } from "@/components/doc/right-sidebar/active-node-style/variable/VariableStyle";

import type { NodeModel } from "@/models/nodes/types";

type Props = {
  node: NodeModel;
};

export const ActiveNodeSelector = observer(function ActiveNodeSelector({ node }: Props) {
  switch (node.type) {
    case "variable": {
      return <VariableStyle node={node} />;
    }

    case "constant": {
      return <ConstantStyle node={node} />;
    }

    case "group": {
      return <GroupStyle node={node} />;
    }

    case "number": {
      return <NumberStyle node={node} />;
    }

    case "function": {
      return <FunctionStyle node={node} />;
    }

    case "placeholder": {
      return <PlaceholderStyle node={node} />;
    }

    default: {
      return null;
    }
  }
});
